import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '@/components/app/ProfilePage';

export const Route = createFileRoute('/app/profile')({
  component: ProfilePage,
});
